import * as caseStatus from "./LeadStatus/StatusCase";
import ApiClient from "./ApiClient";
import GeneratableFile, { AvailableGeneratableDocument } from "../types/GeneratableFile";
import { ProductUnion } from "../types/ProductUnion";

const generatableFilesAndAttachmentsConfig: { [key: string]: GeneratableFile[] } = {
  dataLeakContract: [
    {
      value: "dataLeakReplica",
      label: "Replik Datenweitergabe",
      isDisabled: (product: ProductUnion) =>
        product.courtReference === null || product.statementOfDefenseFiledDate === null,
      disabledReasons: (product: ProductUnion) => [
        ...(product.courtReference === null ? ["Gerichtszeichen fehlt."] : []),
        ...(product.statementOfDefenseFiledDate === null ? ["Eingangsdatum der Klageerwiderung fehlt."] : []),
      ],
    },
    {
      value: "statementOfClaim",
      label: "Klageschrift",
      isDisabled: (product) => {
        //this is inconsistent atm since statementOfClaim is a generic template in the backend. as soon as this is cleaned up
        //the data leak specific part should be removed. (its only needed as long as we have old cases without a personal affection anyways)
        return (
          product.leadStatus < caseStatus.STATUS_PREPARE_LAWSUIT || !product.personalAffection.personalAffectionLawFirm
        );
      },
      disabledReasons: (product) => [
        ...(product.leadStatus < caseStatus.STATUS_PREPARE_LAWSUIT
          ? ["Dokument erst ab Status 'Vorbereitung Klage' verfügbar."]
          : []),
        ...(!product.personalAffection.personalAffectionLawFirm
          ? ["Persönliche Betroffenheit der Kanzlei fehlt."]
          : []),
      ],
    },
  ],
};

const buildAvailableGeneratableDocuments = (
  product: ProductUnion,
  files: GeneratableFile[] = []
): AvailableGeneratableDocument[] => {
  return files
    .filter((file) => !file.isHidden?.(product))
    .map((file) => {
      const isDisabled = file.isDisabled?.(product) || false;

      return {
        documentId: file.value,
        label: file.label,
        isDisabled,
        disabledReasons: isDisabled ? file.disabledReasons?.(product) || [] : [],
      };
    });
};

export const fetchGeneratableFiles = async (product: ProductUnion): Promise<AvailableGeneratableDocument[]> => {
  const productType = encodeURIComponent(product.productClassName);
  const productId = encodeURIComponent(String(product.id));

  const response = await ApiClient.get(
    `/lb/services/generate_case_file/available_documents/${productType}/${productId}`
  );

  return response as AvailableGeneratableDocument[];
};

export const generatableFilesAndAttachments = (product: ProductUnion): AvailableGeneratableDocument[] => {
  return buildAvailableGeneratableDocuments(product, generatableFilesAndAttachmentsConfig[product.productClassName]);
};

export const hasGeneratableFilesAndAttachments = (product: ProductUnion): boolean => {
  return generatableFilesAndAttachmentsConfig[product.productClassName]?.some((file) => !file.isHidden?.(product));
};
